import { render, staticRenderFns } from "./StockCard.vue?vue&type=template&id=5ac13483&"
import script from "./StockCard.vue?vue&type=script&lang=ts&"
export * from "./StockCard.vue?vue&type=script&lang=ts&"
import style0 from "./StockCard.vue?vue&type=style&index=0&id=5ac13483&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports